const { ClientTaxDetails } = require('bk-web-app');

const deps = [require('ngreact').name];

module.exports = angular
  .module('bench.ui.bk.clientTaxDetails', deps)
  .directive('clientTaxDetails', reactDirective => reactDirective(ClientTaxDetails));
